import { useQuery } from '@apollo/client';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { FormSection } from '@openx/components-core/lib/FormSection/FormSection';
import { Loader } from '@openx/components-core/lib/Loader/Loader';
import { RIGHT_COLUMN_WIDTH } from '@openx/constants/form';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../../../../../../components/AuthContext/context';
import {
  GetProvidersDocument,
  type GetProvidersQuery,
} from '../../../../../../../graphql/query/audiences/GetProviders.generated';
import { isAdmin } from '../../../../../../../permissions/validators';

type ProviderProps = {
  accountId: string;
  providerId?: string;
};

export function Provider({ accountId, providerId }: ProviderProps) {
  const { t } = useTranslation();
  const { session } = useAuth();
  const accountIdVariables = isAdmin(session) ? { accountId: accountId || '' } : {};
  const { data, loading, error } = useQuery<GetProvidersQuery>(GetProvidersDocument, {
    variables: { ...accountIdVariables },
  });

  const displayValue = data?.provider.find(({ id }) => id === providerId)?.name ?? t('No value');

  return (
    <FormSection divider title={t('Provider')} rightColumnSize={RIGHT_COLUMN_WIDTH}>
      <Stack>
        <Typography variant="body2" color="textSecondary">
          {t('Provider')}
        </Typography>
        {loading && <Loader />}
        {error && <Alert severity="error">{t('Could not get providers data from the server')}</Alert>}
        <Typography variant="body1" data-test="provider-value">
          {displayValue}
        </Typography>
      </Stack>
    </FormSection>
  );
}
